import styled from 'styled-components'

export const InfoBox = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.gray.info};
  border: ${({ theme }) => `1px solid ${theme.gray.info}`};
  border-radius: 50%;
  padding: 0px 5px;
`
